/* eslint-disable consistent-return */
import fs from 'fs-extra';
import path from 'path';

/**
 * Delete files and directories in a folder. Synchronous.
 *
 * @param {string} pathDir - Directorio que se quiere borrar recursivamente.
 * @param {boolean} isRoot - Con este flag le decimos que cuando termine
 * la recursividad y finalmente borre el ultimo directorio,
 * me revuelva el numero de objetos borrados.
 */
let deletedFiles = 0;
let deletedFolders = 0;
export const deleteFolderRecursiveSync = (pathDir, isRoot = true) => {
  try {
    if (isRoot) {
      deletedFiles = 0;
      deletedFolders = 0;
    }
    let files = [];
    if (fs.existsSync(pathDir)) {
      files = fs.readdirSync(pathDir);
      files.forEach(file => {
        const curPath = path.join(pathDir, file);
        if (fs.lstatSync(curPath).isDirectory()) {
          // recurse
          deleteFolderRecursiveSync(curPath, false);
        } else {
          // delete file
          deletedFiles += 1;
          fs.removeSync(curPath);
        }
      });
    }
    if (!isRoot) {
      deletedFolders += 1;
      fs.rmdirSync(pathDir);
    } else {
      deletedFolders += 1;
      fs.rmdirSync(pathDir);
      return { deletedFiles, deletedFolders };
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Delete a file in a given directory.
 *
 * @param {string} dir - Directory.
 * @param {string} fileName - The name of the file to delete.
 * @returns {*} - A Promise which, when resolved, returns a json object with three parameters:
 * result ('error' or 'ok'), dir and filename.
 */
export const deleteFile = (dir, fileName) =>
  new Promise((resolve, reject) => {
    try {
      const completePath = path.join(dir, fileName);
      fs.unlink(completePath, err => {
        if (err) {
          resolve({ result: 'error', dir, fileName });
        } else {
          resolve({ result: 'ok', dir, fileName });
        }
      });
    } catch (error) {
      reject(error);
    }
  });

export const getFileSize = filename => {
  const stats = fs.statSync(filename);
  const fileSizeInBytes = stats.size;
  return fileSizeInBytes;
};
